import { Geometry, Polygon } from 'geojson';
import { StacSearchResponse, CaptureFeatureProperties, StacFeature, StacItemLink, STACCollection } from '../../types';
import {
    addTargetGroupDataToStacItems,
    filterToCapturesAndPointsWithMatchingTotals,
    getLatestProcessedFeatures
} from './stacDataTransformations';

export class StacSearchResponseBuilder<G extends Geometry = Polygon>
    implements StacSearchResponse<G, CaptureFeatureProperties>
{
    type: string;
    features?: StacFeature<G, CaptureFeatureProperties>[] | undefined;
    links?: StacItemLink[] | undefined;
    numberReturned?: number | undefined;
    context?: { limit?: number; returned?: number } | undefined;
    collection: STACCollection;
    id: string;

    constructor(res: StacSearchResponse<G, CaptureFeatureProperties>) {
        this.type = res.type;
        this.features = res.features;
        this.links = res.links;
        this.numberReturned = res.numberReturned;
        this.context = res.context;
        this.collection = res.collection;
        this.id = res.id;
    }

    filterToLatestProcessingIdPerCollection(options?: { skip: boolean }) {
        const { skip } = options ?? { skip: false };
        if (skip) return this;
        this.features = getLatestProcessedFeatures<G>(this.features);
        return this;
    }
    filterToCapturesAndPointsWithMatchingTotals(options?: { skip: boolean }) {
        const { skip } = options ?? { skip: false };
        if (skip) return this;
        this.features = filterToCapturesAndPointsWithMatchingTotals<G>(this.features);
        return this;
    }
    withTargetGroupData() {
        this.features = addTargetGroupDataToStacItems<G>(this.features);
        return this;
    }
    /**
     * This method is necessary to prevent non-serializable data (i.e. the methods of this class)
     * from being added to the state by redux-toolkit-query in apiSlice.
     */
    data() {
        const { type, features, links, numberReturned, context, collection, id } = this;
        return { type, features, links, numberReturned, context, collection, id };
    }
}
